import { useHomeBanner, useServiceAIDictationWizard} from '@/src/api/getData';
import Banner from '@/components/banner';
import Card from '@/components/card';
import DynamicContent from '@/components/dynamicContent';

const ITechDictationView: any = ({ language = '' }) => {
    const { data: banner } = useHomeBanner(language);
    const { data: ITechDictation } = useServiceAIDictationWizard(language);
    let ITechDictationData = ITechDictation?.data || {};

    return (
        <main className='bg-2' id="start">
            <Banner banner={banner} category="AI Dictation Wizard" />
            <Card cardData={ITechDictationData?.Card_video?.Cards || []} cardType="orange-card"/>
            <DynamicContent content={ITechDictationData?.Content} />
        </main>
    );
}
export default ITechDictationView;